const UserComponent = () => import('@/views/User/UserView')

export default [
    {
        path:'/UserIndex',
        name:'UserRouter',
        component:UserComponent
    }
]